import { flagg, localStore } from "@intelligems/ig-flagg";

export const definitions = {
  aiQa: {
    default: false,
    description: "Enable AI QA in the Experiment Preview tab",
  },
  billingSettings2026DynamicSubheader: {
    default: false,
    description: "Dynamic subheader with provider link in Billing Settings",
  },
};

export const featureFlags = flagg({
  store: localStore(),
  definitions,
});
